var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.wait)?_c('div',{staticClass:"wait"},[_c('div',{staticClass:"spinner"},[_c('svg',{attrs:{"viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"length",attrs:{"fill":"none","stroke-width":"8","stroke-linecap":"round","cx":"33","cy":"33","r":"28"}})])])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45505136","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./themes/polza/src/js/components/commerce/wait.vue
// module id = 83
// module chunks = 0